<template lang="pug">
  div
    v-layout(align-center justify-space-between)
      span(class="headline") Jobs
      span(class="caption") You can create a job from an issue.

    v-container(style="padding-top: 0;")

      template(v-if="loadingJobs")
        v-layout(class="mt-5" justify-center)
          v-progress-circular(size="50" indeterminate)

      template(v-else-if="jobs.length === 0")
        v-layout(class="mt-5" justify-center)
          span(class="title") No jobs.

      template(v-else)
        v-layout(justify-center)
          v-flex(xs4)
            v-text-field(
              v-model="search"
              append-icon="search"
              class="ma-0"
              hide-details
              label="Find a job"
            )
        v-layout(class="mt-3")
          v-flex
            v-data-table(
              :custom-filter="filter"
              :headers="headers"
              :items="jobs"
              :pagination.sync="pagination"
              :search="search"
              disable-initial-sort
              hide-actions)
              template(slot="items" slot-scope="props")
                tr
                  td
                    router-link(
                      :to="{ name: 'job', params: { id: props.item.id } }"
                      class="clickable")
                      | {{ props.item.id | formatJId }}
                  td
                    router-link(
                    :to="{ name: 'issue', params: { id: props.item.issueId } }"
                    class="clickable")
                      | {{ props.item.issueId | formatIId }}
                  td
                    span {{ props.item.name }}
              template(slot="no-data")
                v-container
                  v-layout
                    v-flex Please add a job from an issue
        v-layout(justify-center class="mt-3")
          v-flex(xs6)
            div(class="text-xs-center")
              v-pagination(v-model="pagination.page"
                           :length="pages"
                           color="grey darken-2")

</template>

<script>
export default {
  data () {
    return {
      headers: [
        {
          text: "Job ID",
          value: "id",
          // Hack while there is no option to set width: shrink
          width: "10%"
        },
        {
          text: "Issue ID",
          value: "issueId",
          // Hack while there is no option to set width: shrink
          width: "10%"
        },
        {
          text: "Name",
          value: "name"
        }
      ],
      jobs: [],
      loadingJobs: false,
      pagination: { rowsPerPage: 20 },
      search: ""
    };
  },
  computed: {
    pages () {
      if (this.pagination.rowsPerPage == null ||
          this.pagination.totalItems == null) {
        return 0;
      }

      return Math.ceil(
        this.pagination.totalItems / this.pagination.rowsPerPage);
    }
  },
  created () {
    this.loadingJobs = true;
    this.$http.get("/api/jobs").
      then((r) => {
        this.loadingJobs = false;
        this.jobs = Array.from(r.data);
      }).
      catch(() => this.loadingJobs = false);
  },
  methods: {
    filter (items, search) {
      return items.filter((obj) =>
        this.$options.filters.formatJId(obj.id).
          indexOf(search.toUpperCase()) > -1 ||
        this.$options.filters.formatIId(obj.issueId).
          indexOf(search.toUpperCase()) > -1 ||
        obj.name.toLowerCase().indexOf(search.toLowerCase()) > -1);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Jobs.vue